import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconTrendingUp, IconLock, IconChartLine, IconArrowUpRight } from '@tabler/icons-react';
import '../TopicCard/styles.scss';

// A topic card the plan does not include: placeholder content, blurred and out of reach
// of pointer, focus and screen readers, under a veil that leads to the plan.
export default function LockedTopicCard({ sample, studio: s, index, onUnlock }) {
  const { t } = s;
  return <div className="studio-trend-locked" style={{ '--studio-trend-index': index }}>
    <Card className="studio-trend-card is-placeholder" aria-hidden="true" inert="">
      <div className="studio-trend-card__meta"><Text.caption contrast={6} left={<IconTrendingUp />}>{t('trending')}</Text.caption>
        <div className="studio-trend-card__actions"><Button size="small" variant="rounded" color="inverse" dropdown tabIndex={-1}>{t('trendingUse')}</Button></div></div>
      <ul className="studio-trend-card__tags"><li><Text.caption contrast={7}>{sample.category}</Text.caption></li></ul>
      <Text.h5 weight={500} contrast={9} maxLines={3}>{sample.title}</Text.h5>
      <Text.p contrast={7} maxLines={3}>{t('trendingSampleReason')}</Text.p>
      <span className="studio-trend-locked__sources"><i /><i /></span>
      <div className="studio-trend-card__signal"><IconChartLine /><Text.caption contrast={6} maxLines={2}>{t('trendingSampleSignal')}</Text.caption></div>
    </Card>
    <div className="studio-trend-locked__veil">
      <span className="studio-trend-locked__lock" aria-hidden="true"><IconLock /></span>
      {onUnlock ? <Button size="small" variant="rounded" color="ai" endIcon={<IconArrowUpRight />} onClick={onUnlock}>{t('trendingUnlock', { plan: t('planShort_pro') })}</Button>
        : <Text.caption contrast={7}>{t('trendingProOnly', { plan: t('planName_pro') })}</Text.caption>}
    </div>
  </div>;
}
